import { useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from "../../Context/AuthContext";

const getRiders = async ({ pageParam = 1 }, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/riders?page=${pageParam}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch riders');
  }

  return response.json();
};

const useGetRiders = () => {
  const { token } = useContext(AuthContext);

  return useInfiniteQuery(
    ['riders'], 
    ({ pageParam = 1 }) => getRiders({ pageParam }, token),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalRiders } = lastPage;
        const totalPages = Math.ceil(totalRiders / 10); 
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    }
  );
};

export default useGetRiders;







